<template>
    <div class="main">

        <div v-if="loading" style="min-height: 350px; display: flex; justify-content: center; align-items: center;">
            <img src="/public/img/loading-bar.gif" />
        </div>

        <div v-if="dadosTextoAtestado && !loading">
            <el-row :gutter="10">
                <el-col :xs="24" :sm="4" :md="4" v-if="dadosTextoAtestado.situacao != 'ABERTO'">

                        <div style="margin-top: 40px;">

                            <el-row :gutter="10">
                                <el-col :xs="24" :sm="24" :md="24">
                                    <div style="display: flex; flex-direction: column;">
                                        <h3>Última Matrícula</h3>
                                        <el-radio class="u-mt-5" v-model="t1" :label="0">Vazio</el-radio>
                                        <el-radio class="u-mt-5" v-model="t1" :label="1">Preenchido</el-radio>
                                        <el-radio class="u-mt-5" v-model="t1" :label="2">Não utilizado</el-radio>
                                    </div>
                                </el-col>
                            </el-row>

                            <el-row :gutter="10">
                                <el-col :xs="24" :sm="24" :md="24">
                                    <div style="display: flex; flex-direction: column;">
                                        <h3 class="u-mt-30">Próxima Matrícula</h3>
                                        <el-radio class="u-mt-5" v-model="t2" :label="0">Vazio</el-radio>
                                        <el-radio class="u-mt-5" v-model="t2" :label="1">Preenchido</el-radio>
                                        <el-radio class="u-mt-5" v-model="t2" :label="2">Não utilizado</el-radio>
                                    </div>
                                </el-col>
                            </el-row>

                            <el-row :gutter="10">
                                <el-col :xs="24" :sm="24" :md="24">
                                    <div style="display: flex; flex-direction: column;">
                                        <h3 class="u-mt-30">Documentação incompleta</h3>
                                        <el-radio class="u-mt-5" v-model="t3" :label="0">Não</el-radio>
                                        <el-radio class="u-mt-5" v-model="t3" :label="1">Sim</el-radio>                                        
                                    </div>
                                </el-col>
                            </el-row>

                        </div>

                </el-col>
                <el-col :xs="24" :sm="(dadosTextoAtestado.situacao == 'ABERTO') ? 24 : 20" :md="(dadosTextoAtestado.situacao == 'ABERTO') ? 24 : 20">

                    <div class="u-mt-10" v-if="dadosTextoAtestado['opcoes_equivalencia']">
                        <el-row :gutter="10">
                            <el-col :xs="24" :sm="24" :md="24">
                                <label style="font-size: 15px;">Curso regular que o aluno está apto a Cursar</label>
                                <el-select v-model="dadosTextoAtestado.curso_seguinte.equivalencia">
                                    <el-option v-for="(item, i) in dadosTextoAtestado['opcoes_equivalencia']" :key="i" :label="item" :value="item"></el-option>
                                </el-select>
                            </el-col>
                        </el-row>
                    </div>

                    <h3>Prévia do texto da declaração</h3>

                    <p style="color: #ff0000;" v-if="dadosTextoAtestado.situacao == 'ABERTO'">
                        ATENÇÃO: O atestado de transferência de {{ dadosTextoAtestado.aluno.nome }} deverá ser preenchido manualmente.
                    </p>

                    <div class="previa-text-declaracao">

                        <div v-if="dadosTextoAtestado.curso_seguinte.nome == '1º ano do Ensino Médio' || dadosTextoAtestado.curso_seguinte.equivalencia">

                            <p>Declaro que o(a) aluno(a) {{ dadosTextoAtestado.aluno.nome }}, nascido(a) em {{ $moment(dadosTextoAtestado.aluno.data_nascimento).format('DD/MM/YYYY') }}, filho(a) de {{ dadosTextoAtestado.aluno.mae }} {{ (dadosTextoAtestado.aluno.pai) ? ' e ' + dadosTextoAtestado.aluno.pai : '' }}</p>

                            <p v-if="t1 == 0">Foi aluno(a) no ano letivo de __________, na modalidade _____________________________, _____ ano  do Ensino Fundamental de nove anos.</p>

                            <p v-if="t1 == 1">Foi aluno(a) no ano letivo de {{ dadosTextoAtestado.periodo_letivo }}, na modalidade


                                    {{ (dadosTextoAtestado.curso_corrente && dadosTextoAtestado.curso_corrente.nome) &&
                                       (dadosTextoAtestado.curso_corrente.id == 111 ||
                                       dadosTextoAtestado.curso_corrente.id == 110 || 
                                       dadosTextoAtestado.curso_corrente.id == 1179 ||
                                       dadosTextoAtestado.curso_corrente.id == 1147 || 
                                       dadosTextoAtestado.curso_corrente.id == 1181 || 
                                       dadosTextoAtestado.curso_corrente.id == 1159) ? dadosTextoAtestado.curso_corrente.nome : '' }}

                                    {{ ( dadosTextoAtestado.curso_corrente.equivalencia &&
                                         dadosTextoAtestado.curso_corrente.id != 111 &&
                                         dadosTextoAtestado.curso_corrente.id != 110 &&
                                         dadosTextoAtestado.curso_corrente.id != 1179 &&
                                         dadosTextoAtestado.curso_corrente.id != 1147 &&
                                         dadosTextoAtestado.curso_corrente.id != 1181 &&
                                         dadosTextoAtestado.curso_corrente.id != 1159 ) ? dadosTextoAtestado.curso_corrente.equivalencia + ' do Ensino Fundamental de nove anos' : '' }}, sendo considerado(a) <span style="text-transform: uppercase;">{{ dadosTextoAtestado.situacao }}</span> (a). </p>

                            <p v-if="t2 == 0">Solicitou transferência devendo ser matriculado no(a) ________________________________, ____________.</p>

                            <p v-if="t2 == 1">Solicitou transferência devendo ser matriculado no(a)

                                {{ (dadosTextoAtestado.curso_seguinte && dadosTextoAtestado.curso_seguinte.nome) &&
                                   (dadosTextoAtestado.curso_seguinte.id == 111 ||
                                   dadosTextoAtestado.curso_seguinte.id == 110 ||
                                   dadosTextoAtestado.curso_seguinte.id == 1179 ||
                                   dadosTextoAtestado.curso_seguinte.id == 1147 ||
                                   dadosTextoAtestado.curso_seguinte.id == 1181 ||
                                   dadosTextoAtestado.curso_seguinte.id == 1159) ? dadosTextoAtestado.curso_seguinte.nome : '' }}

                                {{ ( dadosTextoAtestado['curso_seguinte']['equivalencia'] &&
                                     dadosTextoAtestado.curso_seguinte.id != 111 &&
                                     dadosTextoAtestado.curso_seguinte.id != 110 &&
                                     dadosTextoAtestado.curso_seguinte.id != 1179 &&
                                     dadosTextoAtestado.curso_seguinte.id != 1147 &&
                                     dadosTextoAtestado.curso_seguinte.id != 1181 &&
                                     dadosTextoAtestado.curso_seguinte.id != 1159 ) ? dadosTextoAtestado.curso_seguinte.equivalencia + ' do Ensino Fundamental de nove anos' : '' }}

                            <p>Este documento só tem validade sem rasuras e/ou emendas. Este documento só tem validade com assinatura e carimbo do diretor e/ou secretário escolar. O histórico escolar será expedido em trinta dias, a contar desta data.</p>

                            <p v-if="t3 == 1">Há pendência do Histórico Escolar da unidade de ensino anterior.</p>

                            <p v-if="dadosTextoAtestado.curso_seguinte.equivalencia">Obs.: Para escolas municipais de {{ identidade.municipio || 'este município' }}, o código de transferência deste aluno(a) é: {{ dadosTextoAtestado.cod_transferencia }}</p>

                        </div>
                        <div v-else>

                            <div style="display: flex; justify-content: center; align-items: center; height: 250px;">
                                <i>Informe o curso que o aluno deverá ser matriculado caso a instituição de destino não ofereça a possibilidade de cursar dois cursos em um único ano.</i>
                            </div>

                        </div>

                    </div>

                </el-col>
            </el-row>
        </div>
        <span slot="footer" class="dialog-footer">
            <div class="u-text-right">
                <el-button type="danger" @click="closeModal">FECHAR</el-button>
                <el-button class="u-ml-10" type="primary" @click="printAtestado">IMPRIMIR</el-button>
            </div>
        </span>

    </div>
</template>
<script>

import { identidadeMixin } from '@/shared/identidade'

export default {
    // SANEAMENTO DA FASE 2: identidade do município vem do backend.
    mixins: [identidadeMixin],

    props: ['matricula'],
    data: () => ({
        loading: true,
        t1: 1,
        t2: 1,
        t3: 0,
        curso: '',
        dados: { turma: { nome: '' } },
        dadosTextoAtestado: null
    }),
    mounted(){

    },
    methods:{
        getDadosAtestadoTransferencia(){

            this.loading = true;

            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/matricula/getDadosAtestadoTransferencia/${this.matricula}`, this.$store.getters.getHeaderAuth).then(response => {

                if(typeof response.data.throw !== 'undefined'){

                    window.eventBus.$emit('throw', [response.data.throw]);
                    window.eventBus.$emit('loading', false);
                    this.$emit('closeModal');

                }else{

                    this.dadosTextoAtestado = response.data;

                    if(response.data.situacao == "ABERTO"){
                        this.t1 = 0;
                        this.t2 = 0;
                    }

                    this.loading = false;
                }

            });
        } ,
        closeModal(){

            this.$emit('closeModal');
        },
        printAtestado(){

            if(this.dadosTextoAtestado['opcoes_equivalencia'] && !this.dadosTextoAtestado.curso_seguinte.equivalencia){

                window.eventBus.$emit('alert', {msg: 'É necessário selecionar o curso regular que o aluno está apto a Cursar.', type: 'warning'});
                return false;
            }

            window.eventBus.$emit('print', {url: '/api/pdf/renderAtestadoTransferencia', param: { matricula_id: this.matricula, t1: this.t1, t2: this.t2, t3: this.t3, custom_equivalencia: this.dadosTextoAtestado.curso_seguinte.equivalencia }});
            this.$emit('closeModal');
        }
    },
    watch: {
        matricula: {
            immediate: true,
            handler (value) {

                this.getDadosAtestadoTransferencia(value);
            }
        },
    }
}
</script>
